import { AxiosRequestConfig } from 'axios';

import { pluginDraw, pluginSearch, pluginSing } from '../assets/Plugin';
import { request } from '../request';
import {
  IGetWorkspacePluginListReq,
  IGetWorkspacePluginListResp,
  ImageSize,
  PluginDescription,
  PluginType,
} from '../types/plugin';

export const postGetWorkspacePluginList = async (
  data: IGetWorkspacePluginListReq,
  config?: AxiosRequestConfig
): Promise<IGetWorkspacePluginListResp> => {
  // const mockValue: PluginDescription[] = [
  //   {
  //     plugin_type: PluginType.chat_image,
  //     icon_url: pluginDraw.src,
  //     title: '图像生成',
  //     sub_title: '平均耗时 6s',
  //     desc: '在对话型应用中，让 AI 主动说第一段话可以拉近与用户在对话型应用中，让 AI 主动说第一段话可以拉近与用户可以拉近与用户的',
  //     already_online: true,
  //     demo_dialogue: [
  //       {
  //         role_type: 2,
  //         message: '帮我生成一张狗狗的照片',
  //       },
  //       {
  //         role_type: 1,
  //         attachment_image_url:
  //           'https://www.figma.com/file/srQVRoe6tSAyoJ0qEnnG64/image/9a52cdfaf4103b5b13ae2597cf3a8ada7009cb75',
  //       },
  //     ],
  //     chat_image_web_settings: {
  //       image_size_list: [
  //         ImageSize.three_four,
  //         ImageSize.four_three,
  //         ImageSize.one_one,
  //         ImageSize.sixteen_nine,
  //         ImageSize.nine_sixteen,
  //       ],
  //       picture_style_list: [
  //         {
  //           avatar_style_name: '写实',
  //           avatar_style_img_url:
  //             'https://www.figma.com/file/srQVRoe6tSAyoJ0qEnnG64/image/ad8cd481ab29a6b4d9de56b17611788f72058277',
  //         },
  //         {
  //           avatar_style_name: '漫画',
  //           avatar_style_img_url:
  //             'https://www.figma.com/file/srQVRoe6tSAyoJ0qEnnG64/image/ad8cd481ab29a6b4d9de56b17611788f72058277',
  //         },
  //         {
  //           avatar_style_name: '古风',
  //           avatar_style_img_url:
  //             'https://www.figma.com/file/srQVRoe6tSAyoJ0qEnnG64/image/ad8cd481ab29a6b4d9de56b17611788f72058277',
  //         },
  //         {
  //           avatar_style_name: '科幻',
  //           avatar_style_img_url:
  //             'https://www.figma.com/file/srQVRoe6tSAyoJ0qEnnG64/image/ad8cd481ab29a6b4d9de56b17611788f72058277',
  //         },
  //       ],
  //     }, // 图像插件特有的设置
  //   },
  //   {
  //     plugin_type: PluginType.sing,
  //     icon_url: pluginSing.src,
  //     title: '唱歌',
  //     sub_title: '',
  //     desc: '在对话型应用中，让 AI 主动说第一段话可以拉近与用户在对话型应用中，让 AI 主动说第一段话可以拉近与用户可以拉近与用户的',
  //     already_online: false,
  //     demo_dialogue: [],
  //   },
  //   {
  //     plugin_type: PluginType.search,
  //     icon_url: pluginSearch.src,
  //     title: '搜索',
  //     sub_title: '',
  //     desc: '在对话型应用中，让 AI 主动说第一段话可以拉近与用户在对话型应用中，让 AI 主动说第一段话可以拉近与用户可以拉近与用户的',
  //     already_online: false,
  //     demo_dialogue: [],
  //   },
  // ];
  // return { plugin_descriptions: mockValue };
  const url = '/weaver/api/v1/npc/workspace/plugin_list';
  return await request.post(url, data, config || {});
};
